// Weather on the board (0026): only the loose words the kiosk shows itself.
export const kioskWeatherEn = {
    title: 'Weather',
    open: 'Weather: {feel}. Tap for more.',
    stale: 'Weather unknown for now',
    today: 'Today',
    tomorrow: 'Tomorrow',
    close: 'Close',
    feel: { cold: 'cold', chilly: 'chilly', mild: 'nice', warm: 'warm', hot: 'hot' },
    itemLabels: {
        thick_coat: 'Warm coat',
        coat: 'Coat',
        sweater: 'Jumper',
        raincoat: 'Raincoat',
        boots: 'Boots',
        hat_gloves: 'Hat and gloves',
        umbrella: 'Umbrella',
        sunscreen: 'Sunscreen',
        sun_hat: 'Cap on',
        water_bottle: 'Water bottle',
        shorts: 'Shorts',
    },
    day: {
        today: 'This is today',
        tomorrow: 'This is tomorrow',
        temp: 'How warm?',
        tempValue: '{min} to {max} degrees',
        feels: 'It feels {feel}',
        rain: 'Rain',
        rainWords: {
            dry: 'It stays dry',
            small: 'Maybe a little shower',
            likely: 'It might rain',
            wet: 'It is going to rain',
        },
        rainWhen: 'From {from} to {until}',
        wind: 'Wind',
        windWords: {
            calm: 'Hardly any wind',
            light: 'A little wind',
            fresh: 'Quite windy',
            strong: 'Strong wind',
            very_strong: 'Very strong wind',
        },
        windForce: 'Force {bft}',
        sun: 'Sun',
        sunrise: 'Up at {time}',
        sunset: 'Down at {time}',
        uvWords: {
            moderate: 'The sun is strong. Outside for long? Then sun cream.',
            high: 'The sun is very strong. Sun cream and a cap.',
        },
        course: 'How does the day go?',
        back: 'Back',
        now: 'Now',
    },
};
//# sourceMappingURL=kioskWeather.en.js.map